<template>
  <v-tabs class="pl-1" style="position: relative;" :hide-slider="true">

    <ClearFiltersBtn v-if="showClearFilter" :pk="pk" class="ml-3 mr-2" style="margin-top: 10px;" />

    <v-tab v-if="showFilterTab" class="px-3 rounded-tab" :class="filterTabIsOpen ? 'flowout' : ''"
      style="min-width: unset;" @click="filterTabIsOpen = !filterTabIsOpen">
      <v-badge dot color="warning" offset-y="8" offset-x="5" :value="isFilteredSearchExcluded">
        <v-icon size="20" :color="filterTabIsOpen ? 'tertiary' : 'rgba(0, 0, 0, 0.54)'">mdi-filter</v-icon>
      </v-badge>
    </v-tab>

    <v-tab v-if="showSortingTab" class="px-3 rounded-tab" :class="sortingTabIsOpen ? 'flowout' : ''"
      style="min-width: unset;" @click="sortingTabIsOpen = !sortingTabIsOpen">
      <v-badge dot color="warning" offset-y="8" offset-x="5" :value="isSorted">
        <v-icon size="20" :color="sortingTabIsOpen ? 'tertiary' : 'rgba(0, 0, 0, 0.54)'">mdi-sort</v-icon>
      </v-badge>
    </v-tab>

    <FilterSearch v-if="showSearch && !filterTabIsOpen && !sortingTabIsOpen" :pk="pk" class="mt-2 ml-2" />
  </v-tabs>
</template>


<script>
import ClearFiltersBtn from "@/components/Buttons/ClearFiltersBtn.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterSearch from "@/views/layouts/FilterSearch.vue";

export default {
  name: "FilterTabs",
  props: {
    pk: String,
    showFilterTab: Boolean,
    showSortingTab: Boolean,
    showClearFilter: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ClearFiltersBtn,
    FilterSearch,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    filterTabIsOpen: {
      get() { return (this.$route.query?.[this.pk + 'filter'] == 'filter'); },
      set(val) {
        var query = Object.assign({}, this.$route.query);
        query[this.pk + 'filter'] = (val ? 'filter' : undefined);
        this.$router.replace({ query });
      }
    },

    sortingTabIsOpen: {
      get() { return (this.$route.query?.[this.pk + 'filter'] == 'sort'); },
      set(val) {
        var query = Object.assign({}, this.$route.query);
        query[this.pk + 'filter'] = (val ? 'sort' : undefined);
        this.$router.replace({ query });
      }
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>

</style>